var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{ref:"gymSectorSvgAvatar",staticClass:"gym-sector-svg-avatar",attrs:{"size":_vm.size,"tile":""},domProps:{"innerHTML":_vm._s(_vm.gymSector.gym_space.svg_sectors)}})
}
var staticRenderFns = []

export { render, staticRenderFns }